// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmbeddedAmountPropertyDto
 */
export interface IEmbeddedAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IEmbeddedAmountPropertyDto
     */
    embedded_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmbeddedAmountPropertyDto
     */
    embedded_amount_state?: IEmbeddedAmountPropertyDtoEmbeddedAmountStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEmbeddedAmountPropertyDtoEmbeddedAmountStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IEmbeddedAmountPropertyDto interface.
 */
export function instanceOfIEmbeddedAmountPropertyDto(value: object): value is IEmbeddedAmountPropertyDto {
    return true;
}

export function IEmbeddedAmountPropertyDtoFromJSON(json: any): IEmbeddedAmountPropertyDto {
    return IEmbeddedAmountPropertyDtoFromJSONTyped(json, false);
}

export function IEmbeddedAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmbeddedAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'embedded_amount': json['embedded_amount'] == null ? undefined : json['embedded_amount'],
        'embedded_amount_state': json['embedded_amount_state'] == null ? undefined : json['embedded_amount_state'],
    };
}

export function IEmbeddedAmountPropertyDtoToJSON(json: any): IEmbeddedAmountPropertyDto {
    return IEmbeddedAmountPropertyDtoToJSONTyped(json, false);
}

export function IEmbeddedAmountPropertyDtoToJSONTyped(value?: IEmbeddedAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'embedded_amount': value['embedded_amount'],
        'embedded_amount_state': value['embedded_amount_state'],
    };
}

